import ui from '@/utils/ui'

const state = {
  fullscreen: false,
  spread: true,
  leftMenuOpen: false,
  zoom: false,
  spinner: false
}

const getters = {
  fullscreen: state => state.fullscreen,
  spread: state => state.spread,
  leftMenuOpen: state => state.leftMenuOpen,
  zoom: state => state.zoom,
  spinner: state => state.spinner
}

const actions = {
  enterFullscreen ({ commit }) {
    commit('enterFullscreen')
  },
  exitFullscreen ({ commit }) {
    commit('exitFullscreen')
  },
  toggleSpread ({ commit }) {
    commit('toggleSpread')
  },
  setSpread ({ commit }, value) {
    commit('setSpread', value)
  },
  toggleLeftMenu ({ commit }) {
    commit('toggleLeftMenu')
  },
  toggleZoom ({ commit }) {
    commit('toggleZoom')
  },
  toggleSpinner ({ commit }) {
    commit('toggleSpinner')
  }
}

const mutations = {
  enterFullscreen (state) {
    ui.enterFullscreen(document.documentElement)
    state.fullscreen = true
  },
  exitFullscreen (state) {
    ui.exitFullscreen(document.documentElement)
    state.fullscreen = false
  },
  toggleSpread (state) {
    state.spread = !state.spread
  },
  setSpread (state, value) {
    state.spread = value
  },
  toggleLeftMenu (state) {
    state.leftMenuOpen = !state.leftMenuOpen
  },
  toggleZoom (state) {
    state.zoom = !state.zoom
  },
  toggleSpinner (state) {
    state.spinner = !state.spinner
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js